import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChallengeOfTheDay from './components/ChallengeOfTheDay';
import EcoQuiz from './components/EcoQuiz';

const ChallengeHomepageOrganizer = () => {

    return (
        <>
            <ChallengeOfTheDay />
            <EcoQuiz />

            <ToastContainer
                position="top-right"
            />
        </>
    );
}

export default ChallengeHomepageOrganizer;